import { InputProps } from "antd";
import { StyledInput } from "./atom";

export function Input({ className = "", ...props }: InputProps) {
  return (
    <StyledInput className={`renderbus-ui--input ${className}`} {...props} />
  );
}
